import router, { routerWhiteList } from './router'
import store from './store'
import NProgress from 'nprogress' // 进度条
import 'nprogress/nprogress.css' // 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // 进度条配置

const whiteList = routerWhiteList // ['/login'] // 不重定向白名单

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  if (getToken()) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next('/index')
      NProgress.done()
    } else {
      if (store.getters.info && store.getters.info.name) {
        next()
      } else {
        try {
          await store.dispatch('GetInfo')
          // 获取权限菜单生成可访问的路由表
          const accessRoutes = await store.dispatch('permission/generateRoutes')

          // 动态添加可访问路由表
          router.addRoutes(accessRoutes)

          if (to.path === '/404' && to.redirectedFrom) {
            // 解决F5刷新问题
            console.log({ ...to, path: to.redirectedFrom, replace: true })
            next({ ...to, path: to.redirectedFrom, replace: true })
          } else {
            // hack方法 确保addRoutes已完成 ,设置replace: true，这样导航就不会留下历史记录
            next({ ...to, replace: true })
          }
        } catch (error) {
          await store.dispatch('FedLogOut')
          Message.error(error || '验证失败，请重新登录')
          // next(`/login?redirectedFrom=${to.path}`)
          next('/index')
        }
      }
    }
  } else {
    /* has no token */
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      // next(`/login?redirect=${to.path === '/404' && to.redirectedFrom ? to.redirectedFrom : to.path}`) // 否则全部重定向到登录页
      next('/index')
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})
